import React from 'react';
import {useProviderProfile} from "../../../../../ProviderProfileProvider";
import {KensuTable} from "../../../../../components/table/KensuTable";
import {TabbedPageHeader} from "../../../../../components/TabbedPageHeader";
import {findClassTemplate, findPriceCategory, findService} from "../../Calendar/CalendarUtil";
import {priceToString} from "../../../../../util/PriceUtil";
import {useCatalogTabs} from "../CatalogRouter";
import {useNavigateWithParams} from "../../../../../util/NavUtils";

export const ClassPacks = () => {

  const {businessProfile} = useProviderProfile();
  const navigate = useNavigateWithParams();
  const catalogTabs = useCatalogTabs();

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Catalog'}
                      buttons={[{text: 'Add Package', link: 'add'}]}
                      tabs={catalogTabs}/>

    <div className={'ProviderToolAreaContent'}>

      Let’s help your clients discover your offerings. Here's where you curate your services and/or classes, packages,
      and pricing.
      <br/><br/>

      <KensuTable data={businessProfile?.pricing?.packages}
                  onRowSelected={(row) => navigate(`edit/${row.id}`)}
                  columns={[
                    {label: 'Name', render: (r) => r.displayName, sortString: r => r.displayName, showArchivedBadge: r => r.archived},
                    {
                      label: '# of Classes / Services',
                      render: r => r.classLimit == 0 ? 'Unlimited' : r.classLimit,
                      sortOrder: r => r.classLimit
                    },
                    {
                      label: 'Included Classes / Services',
                      render: r => r.includedClassOrServiceIds?.map(id => {
                        return findClassTemplate(businessProfile, id)?.name ?? findService(businessProfile, id)?.name;
                      }).join(', '),
                    },
                    {label: 'Price', render: r => priceToString(r.price, true), sortOrder: r => r.price?.amount},
                  ]}
      />

      {!businessProfile?.pricing?.packages?.length && <div style={{padding: 15}}>
        <b>No packages listed yet. </b> Click <b>“Add”</b> to create your first package.
      </div>}

    </div>
  </div>

};

